<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="28px" height="28px" version="1.1" viewBox="0 0 28 28">
    <g
      fill="none"
      fill-rule="evenodd"
      stroke="none"
      stroke-width="1"
      transform="matrix(1.414214, 0, 0, 1.414214, -2.970563, -2.970563)"
    >
      <g
        transform="translate(12.000000, 12.000000) rotate(-315.000000) translate(-12.000000, -12.000000) translate(5.000000, 5.000000)"
      />
      <path
        style="fill: var(--v-secondary-base)"
        d="M12,10.5857864 L17.2928932,5.29289322 C17.6834175,4.90236893 18.3165825,4.90236893 18.7071068,5.29289322 C19.0976311,5.68341751 19.0976311,6.31658249 18.7071068,6.70710678 L13.4142136,12 L18.7071068,17.2928932 C19.0976311,17.6834175 19.0976311,18.3165825 18.7071068,18.7071068 C18.3165825,19.0976311 17.6834175,19.0976311 17.2928932,18.7071068 L12,13.4142136 L6.70710678,18.7071068 C6.31658249,19.0976311 5.68341751,19.0976311 5.29289322,18.7071068 C4.90236893,18.3165825 4.90236893,17.6834175 5.29289322,17.2928932 L10.5857864,12 L5.29289322,6.70710678 C4.90236893,6.31658249 4.90236893,5.68341751 5.29289322,5.29289322 C5.68341751,4.90236893 6.31658249,4.90236893 6.70710678,5.29289322 L12,10.5857864 Z"
        transform="translate(12.000000, 12.000000) rotate(-315.000000) translate(-12.000000, -12.000000) "
      />
    </g>
  </svg>
</template>
